import { render, staticRenderFns } from "./circle.vue?vue&type=template&id=f6aee8e2&"
import script from "./circle.vue?vue&type=script&lang=js&"
export * from "./circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6aee8e2')) {
      api.createRecord('f6aee8e2', component.options)
    } else {
      api.reload('f6aee8e2', component.options)
    }
    module.hot.accept("./circle.vue?vue&type=template&id=f6aee8e2&", function () {
      api.rerender('f6aee8e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/circle/circle.vue"
export default component.exports